import { comCheckPaymentAction, fsComCheckPaymentAction } from "@mobile-dev/platform/common/redux/actions/ComCheckPaymentAction";
import { comCheckFuelCardAction, FSComCheckFuelCardAction } from "@mobile-dev/platform/common/redux/actions/ComCheckFuelCardAction";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { AppConstatnt } from "../../../../../Utils/AppConstant";
import { getApplicationFlow, getCarrierEnteredMobileNumber, getTheme, isEclipseOpsTruck, isValidCard, showAlert } from "../../../../../Utils/Utility";
import PaymentMethod from "./PaymentMethod";
import { clearError, clearComCheckPreEdit } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import BilledHeader from "../BilledHeader";
import { Alert } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import TransactionDialog from "../../../../Common/TransactionDialog";
import LoaderButton from "../../../../Common/LoaderButton";
import ErrornDialog from "../../../../Common/ErrorDialog/ErrorDialog";
import { Link } from "react-router-dom";
import ComCheckFuelCardDialog from "./ComCheckFuelCardDialog";
import { isEmpty } from 'lodash';
import { injectIntl } from 'react-intl';
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";

function ComCheckPayment({ intl, ...props }) {
    const id = props.location.state.id;
    const dispatch = useDispatch();
    const comCheckTransaction = useSelector(state => state.comCheckPayment);
    const comCheckPreEdit = useSelector(state => state.comCheckFuelCard.comCheckpreEdit);
    const comCheckFuelCardError = useSelector(state => state.comCheckFuelCard.error);
    const location = useLocation();
    const amount = location.state.amount;
    const originalAmount = location?.state?.originalAmount;
    const serviceFee = location.state.serviceFee;
    const remainingAmount = location.state.remainingAmount;
    const selection = location.state.selection;
    const total_bill_amount = location.state.total_bill_amount;
    const paymentmethods = location.state.paymentmethods;
    const [comcheckDetails, setcomcheckDetails] = useState("");
    const [paymentData, setpaymentData] = useState({ val1: "", val2: "" });
    const [valid, setValid] = useState(false);
    const [show, setShow] = useState(false);
    const [errorStatus, setErrorStatus] = useState('');
    const [tip1show, settip1Show] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const comCheckFuelCardtTransaction = useSelector(state => state.comCheckFuelCard);
    const [isFuelCard, setIsFuelCard] = useState(false);
    const [unitNumber, setUnitNumber] = useState('');
    const [tripNumber, setTripNumber] = useState('');
    const [driverNumber, setDriverNumber] = useState('');
    const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);
    const load_control_num = load?.load_control_num;
    const warehouse_id = load?.warehouse_id;
    const { formatMessage } = intl;
    let driver_phone = getApplicationFlow() === 'Carrier' ? getCarrierEnteredMobileNumber() : userData.phone_number;


    useEffect(() => {
        dispatch(clearError());
        dispatch(clearComCheckPreEdit());
    }, []);

    useEffect(() => {
        if (paymentData.val1.startsWith(556735) || paymentData.val1.startsWith(556736) || paymentData.val1.startsWith(560017) || paymentData.val1.startsWith(555622)) {
            setIsFuelCard(true);
            // showAlert(toast.TYPE.WARNING, 'Fuel Cards payments are temporarily not accepted at this time');
        }
        else {
            setIsValid(isValidCard(paymentData.val1));
            setIsFuelCard(false);
        }

    }, [paymentData.val1]);

    function handleChange(e) {
        setpaymentData({
            ...paymentData,
            [e.target.name]: e.target.value
        });

    }

    function handleUnitNumber(e) {
        setUnitNumber(e.target.value);
    }

    function handleTripNumber(e) {
        setTripNumber(e.target.value);
    }

    function handleDriverNumber(e) {
        setDriverNumber(e.target.value);
    }

    const onShowAlert = () => {
        setShow(true)
        window.setTimeout(() => {
            setShow(false)
        }, 10000)

    }

    useEffect(() => {

        if (comCheckFuelCardError?.response.status === 400 && !isEmpty(comCheckFuelCardError?.response.data)) {
            setErrorStatus(formatMessage({ id: "app.error_content" }));
            onShowAlert();

        }
        else if (comCheckFuelCardError?.response.status === 400 && isEmpty(comCheckFuelCardError?.response.data)) {
            setErrorStatus(formatMessage({ id: "app.error_content" }));
            onShowAlert();
        }
        else {
            setShow(false);
        }
    }, [comCheckFuelCardError?.response]);

    useEffect(() => {
        if (comCheckTransaction.error?.response.status === 400 && !isEmpty(comCheckTransaction.error?.response.data)) {

            switch (comCheckTransaction.error?.response.data) {
                case 'Balance Exceeded':
                    setErrorStatus(AppConstatnt.comdata_error_response.BALANCEEXCEEDED);
                    break;
                case 'INVALID CUSTOMER CODE':
                    setErrorStatus(AppConstatnt.comdata_error_response.INVALIDCUSTOMERCODE);
                    break;
                case 'TRY CHECK AUTH':
                    setErrorStatus(AppConstatnt.comdata_error_response.TRYCHECKAUTH);
                    break;
                case 'INVALID SEQ NR':
                    setErrorStatus(AppConstatnt.comdata_error_response.INVALIDSEQNR);
                    break;
                case 'INVALID AMOUNT REQUESTED':
                    setErrorStatus(AppConstatnt.comdata_error_response.INVALIDAMOUNTREQUESTED);
                    break;
                case 'INVALID EXPRESS CODE':
                    setErrorStatus(AppConstatnt.comdata_error_response.INVALIDEXPRESSCODE);
                    break;
                case 'Driver Number is Required':
                    setErrorStatus(AppConstatnt.comdata_error_response.INVALIDDRIVERNUMBER);
                    break;
                case 'Unit Number is Required':
                    setErrorStatus(AppConstatnt.comdata_error_response.INVALIDUNITNUMBER);
                    break;
                case 'Trip Number Required':
                    setErrorStatus(AppConstatnt.comdata_error_response.INVALIDTRIPNUMBER);
                    break;

                default:
                    setErrorStatus(comCheckTransaction.error?.response.data);
                    break;
            }

            onShowAlert();

        }
        else if (comCheckTransaction.error?.response.status === 400 && isEmpty(comCheckTransaction.error?.response.data)) {
            setErrorStatus(formatMessage({ id: "app.error_content_comdata" }))
            onShowAlert();
        }
        else {
            setShow(false);
        }

    }, [comCheckTransaction.error?.response]);

    function handleSubmit() {

        if (paymentData.val1.length === 14 || paymentData.val1.length === 18 || paymentData.val1.length === 23) {
            if (isEclipseOpsTruck(load)) {
                const transactionData = {
                    recID: id,
                    transactionType: "EXPRESS_CODE",
                    paymentCode: paymentData.val1,
                    driverLastName: userData.family_name,
                    driverFirstName: userData.given_name,
                    carrierName: "",
                    fullAmount: amount,
                    driverPhoneNumber: driverNumber,
                    transactionDateTime: moment(),
                    timeZone: "UTC+6",
                    unitNum: unitNumber,
                    tripNum: tripNumber,
                    relaySiteId: warehouse_id,
                    tabletype: "eclipseOps",
                    serviceFee: serviceFee,
                    paymentType: selection,
                    user_number: driver_phone,
                }
                dispatch(fsComCheckPaymentAction(transactionData))
            } else {
                setcomcheckDetails(paymentData.val1)
                const data = {
                    "amount": amount,
                    "express_code": paymentData.val1,
                    "load_id": id,
                    "last_name": userData.family_name,
                    "first_name": userData.given_name,
                    "warehouse_id": warehouse_id,
                    "driver_number": driverNumber,
                    "unit_num": unitNumber,
                    "trip_num": tripNumber,
                    load_control_num: load_control_num
                    // "check_num": '',  // Can be an empty string,

                }
                dispatch(comCheckPaymentAction(data));
            }
        }
        else if (paymentData.val1.length === 10 || paymentData.val1.length === 16) {
            // showAlert(toast.TYPE.WARNING, 'Fuel Cards payments are temporarily not accepted at this time');
            if (isEclipseOpsTruck(load)) {
                const transactionData = {
                    recID: id,
                    transactionType: "PRE_EDIT",
                    cardNumber: paymentData.val1,
                    driverLastName: auth?.user?.attributes?.family_name,
                    driverFirstName: auth?.user?.attributes?.given_name,
                    driverPhoneNumber: driverNumber,
                    transactionDateTime: moment(),
                    timeZone: "UTC+6",
                    unitNum: unitNumber,
                    relaySiteId: warehouse_id,
                    tabletype: "eclipseOps",
                    user_number: driver_phone,
                }
                dispatch(FSComCheckFuelCardAction(transactionData))
            } else {
                const data =
                {
                    "card_num": paymentData.val1,
                    "unit_num": unitNumber,
                    "load_id": id,
                    "warehouse_id": warehouse_id

                }
                dispatch(comCheckFuelCardAction(data));
            }
        }
        else {
            showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.comdata_money_code_tooltip" }))
        }
    }

    const handleEmail = () => {
        window.open(`mailto:support@freightsmith.net?subject=${load_control_num}&body=Body%20goes%20here`)
    }

    const getTransID = () => {
        if (comCheckTransaction?.ComChecktransactionStatus?.status === "closed" || comCheckFuelCardtTransaction?.comCheckFuelCardtTransaction?.status === "closed") {
            return 'Success'
        }
        else if (comCheckTransaction?.ComChecktransactionStatus) {
            return comCheckTransaction?.ComChecktransactionStatus
        }
        else if (comCheckFuelCardtTransaction?.comCheckFuelCardtTransaction) {
            return comCheckFuelCardtTransaction?.comCheckFuelCardtTransaction
        } else {
            return null
        }
    }

    const getAmount = () => {
        if (isEclipseOpsTruck(load)) {
            return parseFloat(amount) - parseFloat(serviceFee)
        } else {
            return originalAmount
        }
    }

    return (

        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <BilledHeader path={`/paymentconfirmation/${id}`} amount={getAmount()} remainingAmount={remainingAmount} selection={selection} total_bill_amount={total_bill_amount} paymentmethods={paymentmethods} />
                    <div className="container_block" style={{ padding: '40px' }}>
                        <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                            <div className="row">
                                {show &&
                                    <div className="col-md-8">
                                        <Alert variant="danger" onClose={() => setShow(false)} dismissible >
                                            {isFuelCard ? <>{errorStatus}<input className="btn-bg-none text-primary" type="button" onClick={handleEmail} value="support@freightsmith.net"></input>{formatMessage({ id: "app.thank_you" })}</> : errorStatus}
                                        </Alert>
                                    </div>
                                }
                            </div>
                            <section id="relayPayment_hide">
                                <h4 className="mb-3 txtwhite">{formatMessage({ id: "app.comdata_payment" })}</h4>
                                <p>{formatMessage({ id: "app.total_amount_to_pay" })}<strong className="remaining_amt">${amount}</strong></p>
                                <div className="row mt-4">
                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="comcheckPaymentCode">{formatMessage({ id: "app.express_code_fuel_card" })}</label>
                                            <Tooltip title={formatMessage({ id: "app.comdata_money_code_tooltip" })} enterTouchDelay={0} arrow>
                                                <input type="text" name="val1" id="comCheckMoneyCode" data-tip data-for='comCheckMoneyCode'
                                                    className="form-control" placeholder={formatMessage({ id: "app.express_code_fuel_card" })} onChange={handleChange} onClick={() => settip1Show(true)} />
                                            </Tooltip>
                                        </div>
                                        {isValid && <div className="error mb-2" style={{ color: "#f97474" }}>{formatMessage({ id: "app.comdata_valid_card_content" })}
                                            <Link to={{
                                                pathname: `/selectPayment/${id}`,
                                                state: { selection, remainingAmount, amount, id } // your data array of objects
                                            }}><b className='text-orange ml-1'>{formatMessage({ id: "app.click_here" })}</b></Link> </div>}

                                        <div className="form-group">
                                            <label htmlFor="unitNumber">{formatMessage({ id: "app.unit_number" })}</label>
                                            <input type="text" name="unitNumber"
                                                className="form-control" placeholder={`${formatMessage({ id: "app.enter" })} ${formatMessage({ id: "app.unit_number" })}`} onChange={handleUnitNumber} />
                                        </div>
                                        {!isFuelCard &&
                                            <>
                                                <div className="form-group">
                                                    <label htmlFor="driverNumber">{formatMessage({ id: "app.driver_number" })}</label>
                                                    <input type="text" name="driverNumber"
                                                        className="form-control" placeholder={`${formatMessage({ id: "app.enter" })} ${formatMessage({ id: "app.driver_number" })}`} onChange={handleDriverNumber} />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="tripNumber">{formatMessage({ id: "app.trip_number" })}</label>
                                                    <input type="text" name="tripNumber"
                                                        className="form-control" placeholder={`${formatMessage({ id: "app.enter" })} ${formatMessage({ id: "app.trip_number" })}`} onChange={handleTripNumber} />
                                                </div>
                                            </>
                                        }
                                    </div>



                                    {(comCheckTransaction?.ComChecktransactionStatus || comCheckTransaction?.ComChecktransactionStatus?.status === "closed" || comCheckFuelCardtTransaction.comCheckFuelCardtTransaction || comCheckFuelCardtTransaction?.comCheckFuelCardtTransaction?.status === "closed") && <TransactionDialog
                                        load_control_num={load_control_num}
                                        transactionId={getTransID()}
                                        statusMessage={comCheckFuelCardtTransaction.comCheckFuelCardtTransaction ? formatMessage({ id: "app.fuel_card_submitted_successfully" }) : formatMessage({ id: "app.express_Code_submitted_successfully" })}
                                        open
                                        id={id}
                                        paymentType={AppConstatnt.COMCHECK}
                                        message={formatMessage({ id: "app.view_payment_details" })}
                                        amount={amount}
                                        remainingAmount={remainingAmount}
                                        selection={selection}
                                        total_bill_amount={total_bill_amount}
                                    />}

                                </div>
                                <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>
                                    <LoaderButton
                                        className="btn btn-chartreuse justify-content-center "
                                        loading={comCheckTransaction.loading || comCheckFuelCardtTransaction.loading}
                                        onButtonClick={handleSubmit}
                                        name={formatMessage({ id: "app.submit" })}
                                    />
                                </div>
                                {comCheckTransaction.error?.message && !errorStatus && <ErrornDialog
                                    error="Sorry you are experiencing an unknown issue. For immediate assistance, please contact our Contact Support Center at (855)752-2878 to speak with an agent. Thank you."
                                    errorresponse={comCheckTransaction.error?.response}
                                    open
                                />}
                                {comCheckPreEdit &&
                                    <ComCheckFuelCardDialog
                                        open
                                        id={id}
                                        preEditDetails={comCheckPreEdit}
                                        card_num={paymentData.val1}
                                        unit_num={unitNumber}
                                        amount={amount}
                                        remainingAmount={remainingAmount}
                                        selection={selection}
                                        warehouse_id={warehouse_id}
                                        total_bill_amount={total_bill_amount}
                                        load_control_num={load_control_num}
                                        serviceFee={serviceFee}
                                    />}
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default injectIntl(ComCheckPayment);